import { setUserProperty, logEvent } from './eventBridge';
import { generateGoogleAnalyticsURL } from '../../config';

const filterAppsKeys = metadata => {
    const propsToSendToNative = [
        'brand',
        'context',
        'jurisdiction',
        'language',
        'locale',
        'vertical',
        'account_id',
        'currency',
        'login_status',
        'reg_status',
        'user_id'
    ];
    const keys = Object.keys(metadata);
    const filteredKeys = keys.filter(key => propsToSendToNative.includes(key));

    return filteredKeys;
};

function initialiseGoogleTagManager() {
    const scripts = [...document.getElementsByTagName('script')];

    const included = scripts.filter(script =>
        script.src.includes('googletagmanager')
    );

    if (included.length === 0 && scripts.length > 0) {
        // eslint-disable-next-line func-names
        (function(w, d, s, l, i) {
            // eslint-disable-next-line no-param-reassign
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            // eslint-disable-next-line one-var, vars-on-top, no-var
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                // eslint-disable-next-line prefer-template, eqeqeq
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = generateGoogleAnalyticsURL(i, dl);
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-57TQ96RL');
    }
}

/* eslint-disable import/prefer-default-export */
export const sendMetadataEvent = (metadata, screenName) => {
    window.dataLayer = window.dataLayer || [];
    if (window.AnalyticsWebInterface || window.webkit) {
        filterAppsKeys(metadata).forEach(key =>
            setUserProperty(key, metadata[key])
        );
        logEvent('screen_view', { screen_name: screenName });
    } else {
        window.dataLayer.push({ event: 'metaData', ...metadata });
    }
    initialiseGoogleTagManager();
};
